import { UPLOADCARE_IMAGE_SIZE_LIMIT } from "../constants.mjs";
export function isUploadcareImageSizeValid(uploadcareImage) {
  var {
    originalHeight,
    originalWidth
  } = uploadcareImage;
  return originalWidth * originalHeight <= UPLOADCARE_IMAGE_SIZE_LIMIT;
}